import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import shopTrackingServices from "../../api/shopTrackingServices";
export const shopVisits = createAsyncThunk(
  "/shopTracking/shopVisits",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await shopTrackingServices.shopVisits(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const productView = createAsyncThunk(
  "/shopTracking/productView",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await shopTrackingServices.productView(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const addInCart = createAsyncThunk(
  "/shopTracking/addInCart",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await shopTrackingServices.addInCart(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

const initialState = {
  shopVisitsItems: {},
  productViewItems: {},
  addInCartItems: {},
  isLoading: false,
  isSuccess: false,
  isError: false,
  errorMessage: "",
  successMessage: "",
};

const shopTrackingSlice = createSlice({
  name: "shopTracking",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(shopVisits.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(shopVisits.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.shopVisitsItems = action.payload || "";
        state.errorMessage = "";
      })
      .addCase(shopVisits.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(productView.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(productView.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.productViewItems = action.payload || "";
        state.errorMessage = "";
      })
      .addCase(productView.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(addInCart.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(addInCart.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.addInCartItems = action.payload || "";
        state.errorMessage = "";
      })
      .addCase(addInCart.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      });
  },
});

export default shopTrackingSlice.reducer;
